import styles from './TiktokLoading.module.scss';

function TiktokLoading() {
  return <div id={styles.loader} className={styles.loader} />;
}

export default TiktokLoading;
